import { Injectable } from '@angular/core';
import { Settings } from '../../core';
import { HttpClient } from '@angular/common/http';
import { CategoriesStorage, ReportsPackage } from '../../documents';
import { UserStorage } from '../../user';
import { Observable, of } from 'rxjs';
import { UnreadReportsStorage } from '../../documents/unread-reports-storage';
import { DocumentsCounterBase } from '../../documents/models/documents-counter';

@Injectable()
export class AdminUnreadReportStorage extends UnreadReportsStorage<DocumentsCounterBase> {
    constructor(
        settings: Settings,
        http: HttpClient,
        categoriesStorage: CategoriesStorage,
        userStorage: UserStorage
    ) {
        super(settings, http, categoriesStorage, userStorage);
    }

    protected getUnreadCounters(): Observable<DocumentsCounterBase[]> {
        return of([]);
    }

    protected recountOnDocumentsReading(updatedReports: ReportsPackage, unreadCounters: DocumentsCounterBase[]): DocumentsCounterBase[] {
        return []; // recalculation is not supported for admin
    }
    protected recountOnCountersUpdating(updatedReports: ReportsPackage, unreadCounters: DocumentsCounterBase[]): DocumentsCounterBase[] {
        return []; // recalculation is not supported for admin
    }
}